import React from 'react'

const ExpertSubcategories = () => {
  return (
    <>
      Expert 
    </>
  )
}

export default ExpertSubcategories
